import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizClosedTranslations: Quiz409Translations = {
  title: '',
  subMessage:
    "Merci de ton intérêt, mais les candidatures sont déjà closes. Rendez-vous l'année prochaine !",
  buttons: {
    back: 'Accueil',
  },
};
